import React, { useCallback } from "react";
import { Box, Link } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const FormHelperTextWithLink = ({
  linkText,
  onClick,
  isDisabled,
  children,
  ...props
}) => {
  // const hasError = props.className.indexOf("error") !== -1;

  const _onClick = useCallback(
    (evt) => {
      evt.preventDefault();

      if (!isDisabled) {
        onClick();
      }
    },
    [isDisabled, onClick]
  );

  return (
    <Box display={"flex"} justifyContent={"space-between"}>
      <p {...props}>{children}</p>

      <Link
        component="button"
        underline={"none"}
        onClick={_onClick}
        // onClick={hasError ? undefined : _onClick}
        // color={hasError ? grey[100] : undefined}
        fontWeight={"bold"}
        style={{ color: isDisabled ? grey[600] : null }}
      >
        {linkText}
      </Link>
    </Box>
  );
};

export default FormHelperTextWithLink;
